import React from 'react';
import { Lightbulb } from 'lucide-react';
export const ZiZuo: React.FC = () => {
  const zizuoExamples = [{
    pillar: '甲寅',
    type: '自坐比肩',
    desc: '干支同气，性格独立自主，自信心强，有时略显固执。'
  }, {
    pillar: '乙丑',
    type: '自坐偏财',
    desc: '注重现实，有理财头脑，配偶多能带来财富或助力。'
  }, {
    pillar: '丙子',
    type: '自坐正官',
    desc: '自我约束力强，做事有原则，配偶多端庄正直。'
  }, {
    pillar: '丁卯',
    type: '自坐偏印',
    desc: '直觉敏锐，思想独特，配偶多包容但沟通可能不在一个频道。'
  }, {
    pillar: '戊申',
    type: '自坐食神',
    desc: '温和宽厚，有口福，懂得享受生活，配偶多才多艺。'
  }, {
    pillar: '己亥',
    type: '自坐正财',
    desc: '踏实稳重，重视家庭，配偶贤惠顾家。'
  }];
  return <div className="space-y-12" data-id="element-480">
      <div className="text-center mb-10" data-id="element-481">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-482">
          日柱自坐
        </h1>
        <p className="text-ink-light" data-id="element-483">
          日干（自己）坐在日支（配偶宫）上的状态，看婚姻与性格的捷径。
        </p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-484">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-485">
          <Lightbulb size={24} data-id="element-486" />
        </div>
        <div data-id="element-487">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-488">
            小白理解法：屁股决定脑袋
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-489">
            "自坐"就是你（日干）屁股底下坐着什么（日支）。
            <br data-id="element-490" />
            日支代表你的内心世界，也代表你的配偶宫（你的家）。
            <br data-id="element-491" />
            坐着"财"，说明你心里总想着赚钱，或者配偶能帮你赚钱；
            <br data-id="element-492" />
            坐着"官"，说明你心里有把尺子，自我要求高，配偶也管着你。
          </p>
        </div>
      </div>

      <section className="space-y-6" data-id="element-493">
        <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-494">
          经典日柱自坐解析
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-495">
          {zizuoExamples.map((item, idx) => <div key={idx} className="bg-white ink-border p-6 rounded-lg card-hover shadow-sm flex items-start gap-4" data-id="element-496">
              <div className="w-16 h-16 rounded-full bg-paper border-2 border-gold/30 flex items-center justify-center text-xl font-serif font-bold text-ink shrink-0" data-id="element-497">
                {item.pillar}
              </div>
              <div data-id="element-498">
                <h3 className="text-lg font-bold text-gold-dark mb-2" data-id="element-499">
                  {item.type}
                </h3>
                <p className="text-ink-light text-sm leading-relaxed" data-id="element-500">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </div>;
};